import {useQuery} from "@tanstack/react-query";
import {Button, Form, FormInstance, InputNumber, Modal, Select, Space, Typography} from "antd";
import React, {useState} from "react";
import {IVettingResponse} from "../../tevapi/interfaces";
import {TEVService} from "../../tevapi/io";
import {simpleSelection} from "../dispositions/selection";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useForm} from "antd/es/form/Form";


interface FormInterface {
  formInstance: FormInstance;
  collectionPK: number;

};

interface VettingFormModalInterface {
  collectionPK: number;
  isOpen: boolean;
  setIsOpen: (arg0: boolean) => void;
  selection: Array<number>;
  setSelection: (arg0: Array<number>) => void;
};

export const VettingFormModal: React.FC<VettingFormModalInterface> = (props) => {
  const [form] = useForm();

  const [waitingForResponse, setWaitingForResponse] = useState(false);


  const handleOK = () => {
    const payload = form.getFieldsValue();
    setWaitingForResponse(true);
    TEVService.get(
      `/collections/${props.collectionPK}/select/`,
      {params: {
        vetting: btoa(JSON.stringify(payload)),
      }}
    ).then(
    (response) => {
      const newSelection = [...props.selection, ...response.data];
      props.setSelection(newSelection);
      setWaitingForResponse(false);
      props.setIsOpen(false)
    }
    );
  };

  return (
    <>
      <Modal
        title="Select by Vetting dispositions"
        open={props.isOpen}
        confirmLoading={waitingForResponse}
        onOk={handleOK}
        onCancel={() => props.setIsOpen(false)}
      >
        <Typography.Text>
          You currently have {props.selection.length} item(s) selected. Your
          selection will be combined with the result of your vetting query.
        </Typography.Text>
        <VettingSelectionForm
          formInstance={form}
          collectionPK={props.collectionPK}
        />
      </Modal>
    </>
  );
};


export const VettingSelectionForm: React.FC<FormInterface> = ({formInstance, collectionPK}) => {

  const vettingQuery = useQuery({
    queryKey: ["vetting-list-by-collection", collectionPK],
    queryFn: async (): Promise<IVettingResponse[]> => {
      const response = await TEVService.get(
        `/vettings/`,
        {params: {
          collection_id: collectionPK
        }}
      );
      return response.data;
    },
  });

  const validQuery = vettingQuery.isLoading || vettingQuery.data === undefined;

  const comparatorOptions = [
    {
      value: "gt",
      label: <FontAwesomeIcon icon="fa-solid fa-greater-than" />,
    },
      {
        value: "lt",
        label: <FontAwesomeIcon icon="fa-solid fa-less-than" />,
      },
        {
          value: "eq",
          label: <FontAwesomeIcon icon="fa-solid fa-equals" />,
        },
  ];

  return (
    <Form form={formInstance} disabled={validQuery}>
      <Form.Item name="vetting" label="Vetting">
        <Select
          placeholder="Vetting to select with"
          options={
            vettingQuery.data?.map(
              (vetting) => ({
                value: vetting.pk,
                key: vetting.pk,
                label: vetting.process.name,
              })
            )
          }
        />
      </Form.Item>
      <Form.Item name="n_vets" label="Minimum # Vets per item">
        <InputNumber placeholder="# of Vets" />
      </Form.Item>
      <Form.List name="discriminators">
        {(fields, {add, remove}, {errors}) => (
          <Space direction="vertical">
            {
              fields.map(({key, name, ...params}) => (
                <Space key={key}>
                  <Form.Item {...params} name={[name, "disposition"]}>
                    {
                      simpleSelection({
                        prefix: "# ",
                        placeholder: "Choose disposition",
                      })
                    }
                  </Form.Item>
                  <Form.Item {...params} name={[name, "comparator"]}>
                    <Select placeholder=">?<" options={comparatorOptions} />
                  </Form.Item>
                  <Form.Item {...params} name={[name, "n_vets"]}>
                    <InputNumber placeholder="# of Vets" />
                  </Form.Item>
                  <Form.Item>
                    <Button danger block onClick={() => remove(name)}>
                      Remove
                    </Button>
                  </Form.Item>
                </Space> 
              ))
            }
            <Form.Item>
              <Button type="dashed" onClick={() => (add())}>
                Add discriminator
              </Button>
            </Form.Item>
          </Space>
        )}
      </Form.List>
    </Form>
  );
};
